import { ForwardedRef, forwardRef, memo } from 'react'
import classNames from 'classnames'

import css from './CarouselCounter.module.scss'

export type CarouselCounterHandle = {
  //
}

import Label from '@/components/Label/Label'

export interface CarouselCounterProps {
  className?: string
  handleRef?: ForwardedRef<CarouselCounterHandle>
  current: number
  total: number
}

export interface ViewProps extends CarouselCounterProps {}

// View (pure and testable component, receives props from the controller)
export const View = forwardRef<HTMLDivElement, ViewProps>(({ className, current, total }, ref) => {
  return (
    <div className={classNames('CarouselCounter', css.root, className)} ref={ref}>
      <Label labelType={3}>{String(current).padStart(2, '0')}</Label>
      <Label className={css.divider} labelType={3}>
        &nbsp;&nbsp;/&nbsp;&nbsp;
      </Label>
      <Label className={css.total} labelType={3}>
        {String(total).padStart(2, '0')}
      </Label>
    </div>
  )
})

View.displayName = 'CarouselCounter-View'

// Controller (handles global state, router, data fetching, etc. Feeds props to the view component)
const CarouselCounter = forwardRef<HTMLDivElement, CarouselCounterProps>((props, ref) => {
  return <View {...props} ref={ref} />
})

CarouselCounter.displayName = 'CarouselCounter'

export default memo(CarouselCounter)
